module.exports = __webpack_public_path__ + "assets/img/6_601_big.b2e30ef8.jpg";